import { formatDateDuration } from '@lyon/utils/extras/formatDateDuration';

export const LABEL = 'Start Course';
export const CONTINUE_LABEL = 'Continue Course';

export const PROMPT = 'start';
export const TYPE = 'course';

export const DESCRIPTION = (consumablePeriod: number) => `This course must be completed in exactly ${formatDateDuration(consumablePeriod)}. This action will start the time limit. Start the course now?`;
